export default __webpack_public_path__ + "static/media/google_review.899e2e92.png";